import {useEffect, useState} from "react";
import {useVisibility} from "./useVisibility";


export const useAppState = (initialState, initialIdleTime = 60000) => {
	// active, background, inactive, offline
	const {visible} = useVisibility();
	const [state, setState] = useState(initialState);
	const ms = 60000;
	const [time, setTime] = useState(new Date());
	const [idleTime, setIdleTime] = useState(initialIdleTime);

	useEffect(() => {
		setTime(new Date());
		if (visible) {
			setState("active");
		}
		else {
			setState("background");
		}
	}, [visible]);

	function throttle(cb, ms) {
		let lastTime = 0;
		return () => {
			const now = Date.now();
			if (now - lastTime >= ms) {
				cb();
				lastTime = now;
			}
		};
	}

	useEffect(() => {
		let timeoutId;
		const handleTimeout = () => {
			if (state !== "inactive") {
				setState("inactive");
			}
		};

		const handleEvent = throttle((e) => {
			if (state !== "active") setState("active");
			window.clearTimeout(timeoutId);
			timeoutId = window.setTimeout(handleTimeout, ms);
		}, idleTime);

		timeoutId = window.setTimeout(handleTimeout, ms);

		window.addEventListener("mousemove", handleEvent);
		window.addEventListener("mousedown", handleEvent);
		window.addEventListener("resize", handleEvent);
		window.addEventListener("keydown", handleEvent);
		window.addEventListener("touchstart", handleEvent);
		window.addEventListener("wheel", handleEvent);

		return () => {
			window.removeEventListener("mousemove", handleEvent);
			window.removeEventListener("mousedown", handleEvent);
			window.removeEventListener("resize", handleEvent);
			window.removeEventListener("keydown", handleEvent);
			window.removeEventListener("touchstart", handleEvent);
			window.removeEventListener("wheel", handleEvent);
			window.clearTimeout(timeoutId);
		};
	}, [ms]);

	useEffect(() => {
		// if state is background for 1 minute, set state to inactive
		let timer;
		if (state === "background") {
			timer = setTimeout(() => {
				setState("inactive");
			}, idleTime);
		}
		return () => clearTimeout(timer);
	}, [state]);

	return {state, time};
};
